export const SAVE_BDC_STATE_ATTR = 'uprince/SAVE_BDC_STATE_ATTR';

export const LOAD_BURN_DOWN_CHART_DATA = 'uprince/LOAD_BURN_DOWN_CHART_DATA';
export const LOAD_BURN_DOWN_CHART_DATA_SUCCESS = 'uprince/LOAD_BURN_DOWN_CHART_DATA_SUCCESS';
export const LOAD_BURN_DOWN_CHART_DATA_FAIL = 'uprince/LOAD_BURN_DOWN_CHART_DATA_FAIL';